import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '6px !important',
    height: '6px',
    background: theme.palette.gray.darkGray,
    borderRadius: '50px',
    marginRight: '6px',
    padding: '5px'
  }
}));

export default function Bullet() {
  const classes = useStyles();

  return (
    <div className={classes.container} />
  );
}
